import AuctionDetails from "./AuctionDetails";

export default AuctionDetails;
